import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Screen from '@/screens'
import { Route } from '@/entity/route'
import { genre, ingredientCategory, method } from '@/scripts/data'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: Route.Top.path,
    name: Route.Top.name,
    component: Screen.Top
  },
  {
    path: Route.Calculation.path,
    name: Route.Calculation.name,
    component: Screen.Calculation
  },
  {
    path: Route.MenuList.path,
    name: Route.MenuList.name,
    component: Screen.MenuList
  },
  {
    path: Route.Search.path,
    name: Route.Search.name,
    component: Screen.Search
  },
  {
    path: Route.SearchByKeyword.path,
    name: Route.SearchByKeyword.name,
    component: Screen.SearchByKeyword
  },
  {
    path: Route.SearchByGenre.path,
    name: Route.SearchByGenre.name,
    component: Screen.SearchByCategory,
    props: () => {
      const newGenre = { ...genre } as Partial<{[key: string]: string}>
      delete newGenre['006']
      delete newGenre['007']
      return {
        category: newGenre,
        type: 'genre'
      }
    }
  },
  {
    path: Route.SearchByMethod.path,
    name: Route.SearchByMethod.name,
    component: Screen.SearchByCategory,
    props: () => {
      return {
        category: method,
        type: 'method'
      }
    }
  },
  {
    path: Route.SearchByIngredient.path,
    name: Route.SearchByIngredient.name,
    component: Screen.SearchByCategory,
    props: () => {
      return {
        category: ingredientCategory,
        type: 'ingredient'
      }
    }
  },
  {
    path: Route.NewMenu.path,
    name: Route.NewMenu.name,
    component: Screen.MenuModify
  },
  {
    path: Route.EditMenu.path,
    name: Route.EditMenu.name,
    component: Screen.MenuModify
  },
  {
    path: Route.SearchCari.path,
    name: Route.SearchCari.name,
    component: Screen.SearchByCategory,
    props: () => {
      const newGenre = { ...genre } as Partial<{[key: string]: string}>
      delete newGenre['006']
      delete newGenre['007']
      return {
        category: newGenre,
        type: 'cari',
        stepInit: 2
      }
    }
  },
  {
    path: Route.SearchMainFood.path,
    name: Route.SearchMainFood.name,
    component: Screen.SearchByCategory,
    props: () => {
      const newGenre = { ...genre } as Partial<{[key: string]: string}>
      delete newGenre['006']
      delete newGenre['007']
      return {
        category: newGenre,
        type: 'main-food',
        stepInit: 2
      }
    }
  }
]

const router = new VueRouter({
  routes,
  base: process.env.BASE_URL
})

export default router
